<template>
  <span>
    <template v-if="!editing">
      <template v-if="priceData.price != null">
        <template v-if="!priceData.isVariation">
          <span :class="{'pricing-rate-changed': priceData.isRateVariation}">
            <Tooltip :label="priceData.diffDescription ? priceData.diffDescription : 'Rate Overridden'" placement="top" v-if="priceData.isRateVariation"><i class="far fa-exclamation-circle"></i></Tooltip>
            {{getSalesRateNameForId(priceData.isRateVariation ? priceData.rateVariationSalesRateId : priceData.salesRateId)}}
          </span>
          | 
        </template>
        <span :class="{'pricing-list-variation': priceData.isVariation, 'pricing-pending-update': priceData.isSalesPendingUpdate}">
          {{priceData.price | formatPriceWithUOM(priceData.uomType)}}
          <Tooltip :label="priceData.diffDescription ? priceData.diffDescription : 'Price Overridden'" placement="top" v-if="priceData.isVariation"><i class="far fa-usd-circle"></i></Tooltip>
          <Tooltip :label="pendingSalesPriceDescription" placement="top" v-if="priceData.isSalesPendingUpdate"><i class="far fa-clock"></i></Tooltip>
        </span>
      </template>
      <template v-else>-</template>
    </template>

    <template v-if="editing">
      <template v-if="priceData.price != null && !priceData.isEditing">
        <template v-if="!priceData.isVariation">
          <a href="#" @click.prevent="displaySalesRatePopover($event)" :class="{'font-weight-bold': priceData.isRateVariation}">
            {{getSalesRateNameForId(priceData.isRateVariation ? priceData.rateVariationSalesRateId : priceData.salesRateId)}}
          </a>
          |
        </template>
        <a href="#" @click.prevent="displayPriceVariationPopover($event)" :class="{'font-weight-bold': priceData.isVariation}">
          {{priceData.price | formatPriceWithUOM(priceData.uomType)}}
        </a>
      </template>
      <template v-if="priceData.price == null">-</template>                                    
    </template>
  </span>
</template>

<script>
export default {
  name: 'PriceListDataCell',
  props: {
    stock: Object,
    priceGroupId: Number,
    serviceRangeId: Number,
    salesRateList: Array,
    editing: Boolean
  },
  computed: {
    priceData() {
      if(this.priceGroupId && this.serviceRangeId)
        return this.stock.priceGroups[this.priceGroupId][this.serviceRangeId]
      else if(this.priceGroupId)
        return this.stock.priceGroups[this.priceGroupId]
      return this.stock.priceData
    },
    pendingSalesPriceDescription() {
      if(!this.priceData || !this.priceData.isSalesPendingUpdate)
        return ''
      if(!this.priceData.isVariation) {
        let rateName = this.getSalesRateNameForId(this.priceData.isRateVariation ? this.priceData.rateVariationSalesRateId : this.priceData.salesRateId)
        let prevPrice = this.$options.filters.formatCurrency(this.priceData.prevCalculatedPrice)

        return `Contains Pending Sales Prices. Was ${prevPrice} at ${rateName}`

      }
      return 'Contains Pending Sales Prices'
    }
  },
  methods: {
    getSalesRateNameForId(salesRateId) {
      let salesRate = this.salesRateList.find(salesRate => salesRate.id == salesRateId)
      if(salesRate)
        return salesRate.name
      return ''
    },
    displaySalesRatePopover(evt) {
      this.$emit('displaySalesRatePopover', { target: evt.target, stock: this.stock, priceGroupId: this.priceGroupId, serviceRangeId: this.serviceRangeId })
    },
    displayPriceVariationPopover(evt) {
      this.$emit('displayPriceVariationPopover', { target: evt.target, stock: this.stock, priceGroupId: this.priceGroupId, serviceRangeId: this.serviceRangeId })
    }
  }
}
</script>